/**
 * Parse product date strings from API (e.g. DD-MM-YYYY or ISO).
 * @param {string|null|undefined} value
 * @returns {Date|null}
 */
export function parseProductDateString(value) {
	if (value == null || value === '') {
		return null
	}
	const s = String(value).trim()
	const dmy = /^(\d{1,2})-(\d{1,2})-(\d{4})$/.exec(s)
	if (dmy) {
		const day = parseInt(dmy[1], 10)
		const month = parseInt(dmy[2], 10) - 1
		const year = parseInt(dmy[3], 10)
		const d = new Date(year, month, day)
		return isNaN(d.getTime()) ? null : d
	}
	const t = Date.parse(s)
	if (!isNaN(t)) {
		return new Date(t)
	}
	return null
}

/**
 * @param {string|null|undefined} value
 * @returns {string}
 */
export function formatProductDisplayDate(value) {
	const d = parseProductDateString(value)
	if (!d) {
		return value ? String(value) : '—'
	}
	return d.toLocaleDateString(undefined, {
		day: '2-digit',
		month: 'short',
		year: 'numeric',
	})
}

/**
 * @param {string|null|undefined} expiryValue
 * @returns {number|null} Days until expiry; negative if past; null if unknown
 */
export function getExpiryDaysRemaining(expiryValue) {
	const d = parseProductDateString(expiryValue)
	if (!d) {
		return null
	}
	const now = new Date()
	now.setHours(0, 0, 0, 0)
	const end = new Date(d.getTime())
	end.setHours(0, 0, 0, 0)
	return Math.round((end - now) / (24 * 60 * 60 * 1000))
}

/**
 * @param {'approved'|'expiry'} kind
 * @param {string|null|undefined} raw
 * @param {string} formatted
 * @returns {string}
 */
export function buildProductDateTooltip(kind, raw, formatted) {
	const base = raw ? String(raw) : ''
	if (kind === 'approved') {
		return base ? `Approved: ${formatted} (source: ${base})` : formatted
	}
	const days = getExpiryDaysRemaining(raw)
	if (days === null) {
		return base ? `Expiry: ${formatted} (source: ${base})` : formatted
	}
	if (days < 0) {
		return `Expired ${Math.abs(days)} day(s) ago. Source: ${base || formatted}`
	}
	if (days === 0) {
		return `Expires today. Source: ${base || formatted}`
	}
	return `Expires in ${days} day(s). Source: ${base || formatted}`
}

/**
 * @param {string|null|undefined} expiryValue
 * @returns {'expired'|'soon'|'ok'}
 */
export function getExpiryUrgency(expiryValue) {
	const days = getExpiryDaysRemaining(expiryValue)
	if (days === null) {
		return 'ok'
	}
	if (days < 0) {
		return 'expired'
	}
	if (days <= 90) {
		return 'soon'
	}
	return 'ok'
}
